import { useEffect, useState } from 'react';

import { formatDailyResponsesCountdown } from 'utils/tutorDailyResponses';

/** Обновляет обратный отсчет до сброса лимита каждую секунду. */
export function useLiveCountdown(resetsAt?: string | null): string {
  const [countdown, setCountdown] = useState('');

  useEffect(() => {
    if (!resetsAt) {
      setCountdown('');
      return undefined;
    }
    const tick = () => setCountdown(formatDailyResponsesCountdown(resetsAt));
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, [resetsAt]);

  return countdown;
}
